import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login, loading } = useAuthStore();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return toast.error('يرجى ملء جميع الحقول');
    const result = await login(form.email, form.password);
    if (result.success) {
      toast.success('مرحباً بعودتك!');
      navigate('/dashboard');
    } else {
      toast.error(result.message || 'بيانات الدخول غير صحيحة');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900 px-4">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-lg">SP</span>
            </div>
            <span className="text-2xl font-bold gradient-text">SPORTIX</span>
          </Link>
          <h1 className="text-2xl font-bold text-white mb-2">أهلاً بعودتك</h1>
          <p className="text-dark-400 text-sm">سجل دخولك للوصول إلى حسابك</p>
        </div>

        <div className="bg-dark-800 border border-dark-700 rounded-2xl p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-dark-300 text-sm mb-1.5 block">البريد الإلكتروني</label>
              <div className="relative">
                <Mail size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-dark-400" />
                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                  placeholder="example@email.com"
                  className="form-input pr-9" />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className="text-dark-300 text-sm">كلمة المرور</label>
                <Link to="/forgot-password" className="text-primary-400 hover:text-primary-300 text-xs transition-colors">نسيت كلمة المرور؟</Link>
              </div>
              <div className="relative">
                <Lock size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-dark-400" />
                <input type={showPass ? 'text' : 'password'} value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••" className="form-input pr-9 pl-10" />
                <button type="button" onClick={() => setShowPass(!showPass)}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-dark-400 hover:text-dark-200">
                  {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading}
              className="btn-primary w-full justify-center py-3 text-base mt-2 disabled:opacity-50">
              {loading ? 'جارٍ الدخول...' : 'تسجيل الدخول'}
            </button>
          </form>

          <p className="text-center text-dark-400 text-sm mt-5">
            ليس لديك حساب؟{' '}
            <Link to="/register" className="text-primary-400 hover:text-primary-300 font-semibold transition-colors">إنشاء حساب جديد</Link>
          </p>
        </div>

        {/* Demo hint */}
        <div className="mt-4 p-3 bg-dark-700/50 border border-dark-600 rounded-xl text-center">
          <p className="text-dark-400 text-xs">للتجربة: <span className="text-primary-400">admin@sportix.com</span> / <span className="text-primary-400">Admin@Sportix2024</span></p>
        </div>
      </div>
    </div>
  );
}
